var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-form',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle,"schema":_vm.schema,"storeNamespace":_vm.storeNamespace,"objectNamespace":_vm.objectNamespace,"objectId":_vm.id,"listOnSave":_vm.listOnSave}})}
var staticRenderFns = []

export { render, staticRenderFns }